<template>
  <!-- 对话框 -->
  <el-dialog title="集团账户" :visible.sync="show" append-to-body :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <el-form label-width="80px">

        <el-form-item label="手机号 :" label-width='130px'>
          <el-input v-model="submit_data.phone" placeholder="请输入手机号" maxlength="11" style="width: 160px;">
          </el-input>
        </el-form-item>


        <el-form-item label="备注 :" label-width='130px'>
          <el-input v-model="submit_data.remarks" style="width: 160px;">
          </el-input>
        </el-form-item>


      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="walletSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.group_wallet_code = _this.data;

      },

    },
    data() {
      return {

        show: false,



        // 表单提交数据
        submit_data: {
          phone: '',
          remarks: '',
          group_wallet_code: '',
        },

        submit_rules: {
          phone: {
            placeholder: '手机号',
            rules: {
              required: true,
              message: '手机号填写不正确',
              regulation: 'eq',
              rulesData: 11
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {

      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.submit_data = {
          phone: '',
          remarks: '',
          group_wallet_code: '',
        };



      },

      // 提交按钮
      walletSubmit() {

        _this.$post(
            '/consumer/addConsumerSubmit',
            _this.submit_data
          )
          .then(res => {

            this.$emit('onSubmit');
            this.closeDialog();


          }).catch((err) => {

          })

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>
